module.exports = __webpack_public_path__ + "static/media/beluga-luxury-bronzer.0517a9f7.jpg";